import React, { useState, useEffect } from "react";
import ChangePassword from "../../components/ChangePassword/ChangePassword";
import axios from "axios";
import BASE_URL from "../../configs/api";
import { getProxyUrl } from "../../utils/proxy";

const Profile = () => {
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [isUsergg, setIsUsergg] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) return;

    setIsLoading(true);

    axios
      .get(`${BASE_URL}/api/auth/profile/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        const data = res.data;
        setUserData({
          email: data.email || "",
          first_name: data.first_name || "",
          last_name: data.last_name || "",
          gender: data.gender || "undefined",
          avatar: data.anh_dai_dien_url || data.anh_dai_dien,
          vai_tro: data.vai_tro,
        });
        setIsUsergg(data.vai_tro === "usergg");
      })
      .catch((err) => {})
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const openPasswordModal = () => setIsPasswordModalOpen(true);
  const closePasswordModal = () => setIsPasswordModalOpen(false);

  if (isLoading) {
    return null;
  }

  return (
    <div className="min-h-[80vh]">
      <h3 className="text-xl md:text-2xl text-white mb-2 font-bold">
        Tài khoản
      </h3>
      <span className="text-gray-400 text-[12px] lg:text-[14px] md:text-base mb-6 md:mb-8">
        {isUsergg
          ? "Tài khoản đăng nhập bằng Google – chỉ có thể chỉnh sửa họ và tên."
          : "Cập nhật thông tin tài khoản"}
      </span>

      <div className="flex flex-col-reverse sm:flex-row gap-8 lg:gap-12 lg:mt-8">
        <div className="flex-grow">
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="mb-4 xl:mb-8">
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-300 mb-1"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                readOnly
                value={userData.email}
                className="block w-full bg-[#191b28] border border-white/10 rounded-md py-2 px-3 text-gray-400 shadow-sm sm:text-sm cursor-not-allowed"
              />
            </div>
            <div className="mb-4 xl:mb-8">
              <label
                htmlFor="first_name"
                className="block text-sm font-medium text-gray-300 mb-1"
              >
                Họ
              </label>
              <input
                type="text"
                id="first_name"
                name="first_name"
                defaultValue={userData.first_name}
                className="block w-full bg-[#191b28] border-[1px] border-white/10 rounded-md py-2 px-3 text-white shadow-sm"
                readOnly={isUsergg}
              />
            </div>
            <div className="mb-4 xl:mb-8">
              <label
                htmlFor="last_name"
                className="block text-sm font-medium text-gray-300 mb-1"
              >
                Tên
              </label>
              <input
                type="text"
                id="last_name"
                name="last_name"
                defaultValue={userData.last_name}
                className="block w-full bg-[#191b28] border-[1px] border-white/10 rounded-md py-2 px-3 text-white shadow-sm"
                readOnly={isUsergg}
              />
            </div>

            {!isUsergg && (
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Giới tính
                </label>
                <div className="flex items-center gap-x-6 gap-y-2 flex-wrap">
                  {["male", "female", "undefined"].map((gender) => (
                    <div className="flex items-center" key={gender}>
                      <input
                        id={`gender-${gender}`}
                        name="gender"
                        type="radio"
                        value={gender}
                        defaultChecked={userData.gender === gender}
                        className="h-4 w-4 text-yellow-500 border-gray-600 focus:ring-yellow-500 accent-yellow-500"
                      />
                      <label
                        htmlFor={`gender-${gender}`}
                        className="ml-2 block text-sm text-gray-300"
                      >
                        {gender === "male"
                          ? "Nam"
                          : gender === "female"
                          ? "Nữ"
                          : "Không xác định"}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <button
              type="submit"
              className="bg-[#FFD875] hover:bg-[#FFD871] text-black text-[14px] font-medium py-2 px-6 rounded-md transition duration-150 ease-in-out"
            >
              Cập nhật
            </button>
          </form>
        </div>

        <div className="flex flex-col items-center mt-6 lg:mt-4">
          <img
            className="w-28 h-28 md:w-32 md:h-32 rounded-full object-cover border-2 border-gray-500 mb-3"
            src={getProxyUrl(userData.avatar)}
            alt="ava"
          />
          {!isUsergg && (
            <button
              type="button"
              className="text-sm flex text-center text-yellow-400 hover:text-yellow-300 font-medium"
            >
              Đổi ảnh đại diện
            </button>
          )}
        </div>
      </div>

      {!isUsergg && (
        <div className="mt-8 pt-6 border-t border-white/10 text-center lg:text-left">
          <button
            type="button"
            className="text-sm text-gray-400 hover:text-yellow-400 cursor-pointer"
            onClick={openPasswordModal}
          >
            Đổi mật khẩu, nhấn vào đây
          </button>
        </div>
      )}

      <ChangePassword
        isOpen={isPasswordModalOpen}
        onClose={closePasswordModal}
      />
    </div>
  );
};

export default Profile;
